import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$6 } from './button.js';
import { d as defineCustomElement$5 } from './dropdown.js';
import { d as defineCustomElement$4 } from './icon.js';
import { d as defineCustomElement$3 } from './menu.js';
import { d as defineCustomElement$2 } from './spinner.js';

const filterCss = "";

const Filter = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.ttChange = createEvent(this, "tt-change", 7);
    this.label = '';
    this.name = '';
    this.value = undefined;
  }
  connectedCallback() {
    this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  onSelectionChange(event) {
    this.value = event.detail.item.value;
    event.preventDefault();
    event.stopPropagation();
    this.ttChange.emit({ value: this.value });
  }
  render() {
    return (h("div", null, h("tt-dropdown", { distance: 10, exportparts: "panel" }, h("tt-button", { slot: "trigger", variant: "ghost", color: "secondary", size: "small", pill: true, caret: true }, this.label), h("tt-menu", { mode: "radio", "onTt-select": this.onSelectionChange }, h("slot", null)))));
  }
  static get style() { return filterCss; }
}, [1, "tt-filter", {
    "label": [513],
    "name": [1],
    "value": [1032]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-filter", "tt-button", "tt-dropdown", "tt-icon", "tt-menu", "tt-spinner"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-filter":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Filter);
      }
      break;
    case "tt-button":
      if (!customElements.get(tagName)) {
        defineCustomElement$6();
      }
      break;
    case "tt-dropdown":
      if (!customElements.get(tagName)) {
        defineCustomElement$5();
      }
      break;
    case "tt-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "tt-menu":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "tt-spinner":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const TtFilter = Filter;
const defineCustomElement = defineCustomElement$1;

export { TtFilter, defineCustomElement };
